/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Upload_PendingInputs */

const en_toast_upload_pending = /** @type {(inputs: Toast_Upload_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pending`)
};

const es_toast_upload_pending = /** @type {(inputs: Toast_Upload_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pendiente`)
};

/**
* | output |
* | --- |
* | "Pending" |
*
* @param {Toast_Upload_PendingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const toast_upload_pending = /** @type {((inputs?: Toast_Upload_PendingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Upload_PendingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_toast_upload_pending(inputs)
	return en_toast_upload_pending(inputs)
});